import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import Home from './pages/Home.jsx';

// Lazy load pages for code splitting
const Contact = lazy(() => import('./pages/Contact.jsx'));
const Services = lazy(() => import('./pages/Services.jsx'));
const ServicePage = lazy(() => import('./pages/ServicePage.jsx'));
const PricingPage = lazy(() => import('./pages/Pricing.jsx'));
const Companies = lazy(() => import('./pages/Companies.jsx'));
const CompanySingle = lazy(() => import('./pages/CompanySingle.jsx'));
const Blog = lazy(() => import('./pages/Blog.jsx'));
const BlogPost = lazy(() => import('./pages/BlogPost.jsx'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy.jsx'));
const NotFound = lazy(() => import('./pages/NotFound.jsx'));

// Simple loading fallback
const LoadingFallback = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '50vh',
    fontSize: '1rem',
    color: '#344955'
  }}>
    Učitavanje...
  </div>
);

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/usluge" element={<Services />} />
          <Route path="/usluge/:slug" element={<ServicePage />} />
          <Route path="/cenovnik" element={<PricingPage />} />
          <Route path="/za-kompanije" element={<Companies />} />
          <Route path="/za-kompanije/:slug" element={<CompanySingle />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/politika-privatnosti" element={<PrivacyPolicy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
